import baseBackendApi from "../main/configuration/baseBackendApi";

export const getReportedSongs = async () => {
  const response = await baseBackendApi.get("/songs/admin/reports");
  return response.data;
};
